import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AddIcon from '@mui/icons-material/Add';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import BarChartIcon from '@mui/icons-material/BarChart';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import FilePresent from '@mui/icons-material/FilePresent';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import HistoryIcon from '@mui/icons-material/History';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ReplayIcon from '@mui/icons-material/Replay';
import Settings from '@mui/icons-material/Settings';

export const MENU_ITEMS = {
  claims: {
    id: 'claims',
    path: '/claims',
    label: 'Claims',
    icon: <AccountBalanceIcon />,
    children: [
      {
        id: 'claims-calendar',
        path: '/claims',
        label: 'Calendar',
        icon: <CalendarMonthIcon />,
      },
      {
        id: 'claims-metrics',
        path: '/claims/metrics',
        label: 'Metrics',
        icon: <BarChartIcon />,
      },
    ],
  },
  billingExport: {
    id: 'billing-export',
    path: '/billing-export',
    label: 'Billing Export',
    icon: <ReceiptLongIcon />,
    children: [
      {
        id: 'billing-export-new',
        path: '/billing-export/new',
        label: 'New Export',
        icon: <FileUploadIcon />,
      },
      {
        id: 'billing-export-history',
        path: '/billing-export/history',
        label: 'Export History',
        icon: <HistoryIcon />,
      },
      {
        id: 'billing-export-stats',
        path: '/billing-export/stats',
        label: 'Statistics',
        icon: <BarChartIcon />,
      },
    ],
  },
  rpm: {
    id: 'rpm',
    path: '/rpms',
    label: 'RPM',
    icon: <MonitorHeartIcon />,
    children: [
      {
        id: 'rpm-core',
        path: '/rpms',
        label: 'Core Process',
        icon: <AccountTreeIcon />,
      },
      {
        id: 'rpm-claims',
        path: '/rpms/claims',
        label: 'Claims Search',
        icon: <AssignmentTurnedInIcon />,
      },
      {
        id: 'rpm-export',
        path: '/rpms/exported-notes-list',
        label: 'Notes Export List',
        icon: <FolderZipIcon />,
      },
      {
        id: 'rpm-clinic-config',
        path: '/rpms/clinics-configuration',
        label: 'Clinic Config',
        icon: <Settings />,
      },
    ],
  },
  documents: {
    id: 'documents',
    path: '/documents',
    label: 'Documents',
    icon: <DocumentScannerIcon />,
    children: [
      {
        id: 'documents-library',
        path: '/documents/library',
        label: 'Library',
        icon: <FilePresent />,
      },
      {
        id: 'documents-settings',
        path: '/documents/settings',
        label: 'Settings',
        icon: <Settings />,
      },
      {
        id: 'documents-bulk-reprocess',
        path: '/documents/bulk-reprocess',
        label: 'Bulk Reprocess',
        icon: <ReplayIcon />,
      },
      {
        id: 'documents-upload',
        path: '/documents/upload',
        label: 'Upload',
        icon: <FileUploadIcon />,
      },
      {
        id: 'referrals-create',
        path: '/referrals/create',
        label: 'Create Referral',
        icon: <AddIcon />,
      },
    ],
  },
};
